import echarts from 'echarts';

//[{ label , value , type}]

const splitLine = (str , len) => {
  return Array(Math.ceil(str.length / len))
  .fill(null)
  .map((_,i) => str.substring(i*len , (i+1)*len))
  .join('\n')
}

const convData = (data , percent = false) => {

  let category = Array.from(new Set(data.map(i => i.label))).map(i => ({label:i}))
  let categoryMap = {}
  category.forEach(i => categoryMap[i.label] = i)
  for(let i of data){
    categoryMap[i.label][i.type] = i.value
  }

  let series = Array.from(new Set(data.map(i => i.type))).map(i => ({type: 'bar'}))

  let options = {
    //g2 themes
    color: ['#5396ff', '#62c564', '#f2cf31', '#3f4780', '#8a54e4', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'],

    tooltip: {
      trigger: 'axis',
      axisPointer: { // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    legend: {},
    dataset:{
      source:category
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      axisLabel: {
        interval:0,
        formatter(value,index){
          let max = Math.round(document.body.offsetWidth / 200)

          if(value.length > max){
            return splitLine(value,max)
          }else{
            return value
          }
        }
      },
    },
    yAxis: {},
    series: series
  };

  if( percent ){
    options.tooltip.formatter = function (params) {
      return (params[0].value[params[0].seriesName] * 100).toFixed(2)+'%';
    };

    options.yAxis.axisLabel = { formatter : function(value,index){
      return (value*100).toFixed(2)+'%';
    }}
  }

  return options
}

export default {
  props: ['data','percent'],
  data() {
    return {
      chart: null,
      // resizeHandler:null
    }
  },
  created(){
    let self = this
    this.resizeHandler = function(){
      if( self.chart ) {
        self.chart.resize()
      }
    }
  },
  mounted() {
    this.$watch('data', function(nv) {
      if (nv) {
        if (!this.chart) {
          this.chart = echarts.init(this.$el);
          window.addEventListener("resize", this.resizeHandler);
        }
        this.chart.setOption(convData(nv , this.percent))
      }
    }, { immediate: true })
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);

    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  render() {
    return <div style="width:100%;height:400px;" />
  }
}

/*import G2 from '@antv/g2';

export default {
  props:['data'],
  data(){
    return {
      chart:null
    }
  },
  mounted(){
    this.$watch('data' , function(nv){
      if(nv){
        if(!this.chart){
          const chart = new G2.Chart({
            container: this.$el,
            forceFit: true,
            height: 500
          });
          chart.source(nv)
          
          chart.interval().position('label*value').color('type')
            .adjust([{
              type: 'dodge',
              marginRatio: 1 / 32
            }])

          chart.legend({
            position: 'top',
            itemGap: 20 
          })

          chart.render()
          this.chart = chart
        }else{
          this.chart.changeData(nv)
        }
      }
    },{immediate:true})
  },
  beforeDestroy(){
    if(this.chart){
      this.chart.destroy()
      this.chart = null
    }
  },
  render(){
    return <div />
  }
}*/
